class DeclinedStageController{
  constructor($scope){
    $scope.splashIconUrl = require('@amount/frontend-styles/src/images/logo/logo-avant-icon.svg')
    $scope.signatureUrl  = require('@amount/frontend-styles/src/images/dec/dec-avant-sig.svg')
  }
}

DeclinedStageController.$inject = ["$scope"];

module.exports = DeclinedStageController
